import React, { FC, Fragment } from "react";
import { ChangeNames } from "../../clients/FirebaseClient/types";
import { useFormModel } from "../core/FormModelHelpes";
import { Switch } from "../core/Switch";
import { ElevatorIcon } from "../core/icons/Icons";
import { BoxedInputWithIconAndOptionalSwitch } from "../core/BoxedInputWithIconAndOptionalSwitch";
import { useStyles } from "../../useStyles";
import { InputLabel } from "@material-ui/core";
import { NumberInput } from "../core/NumberField";
import { FormControlLabel } from "../core/FormControlLabel";
import { Checkbox } from "../core/Checkbox";

export const IncreaseCurrentElectricElevatorForm: FC = () => {
    const classes = useStyles();
    const { values, setValues, getFieldProps } = useFormModel<
        ChangeNames.INCREASE_CURRENT_ELECTRIC_ELEVATOR
    >();
    return (
        <Fragment>
            <BoxedInputWithIconAndOptionalSwitch
                icon={<ElevatorIcon />}
                content={
                    <p className={classes.label} style={{ marginBottom: 24 }}>
                        Aufzugsanlage
                    </p>
                }
                useSwitch={
                    <Switch
                        checked={values.increaseCurrentElectricElevator.value.installed}
                        {...getFieldProps("increaseCurrentElectricElevator.value.installed")}
                        onChange={(e, checked) =>
                            setValues(values => {
                                values.increaseCurrentElectricElevator.value.installed = checked;
                                values.increaseCurrentElectricElevator.value.demand.amount = checked
                                    ? 0
                                    : null;
                            })
                        }
                    />
                }
                detailCondition={values.increaseCurrentElectricElevator.value.installed}
                detail={
                    <Fragment>
                        <InputLabel className={classes.labledTextfieldLabel}>
                            Summe der Leistung
                        </InputLabel>
                        <NumberInput
                            className={classes.textField}
                            fixedDecimalScale={false}
                            allowLeadingZeros={false}
                            decimalScale={
                                values.increaseCurrentElectricElevator.value.demand.precision
                            }
                            isNumericString={false}
                            allowNegative={false}
                            thousandSeparator="."
                            decimalSeparator=","
                            adornment={values.increaseCurrentElectricElevator.value.demand.unit}
                            value={values.increaseCurrentElectricElevator.value.demand.amount || ""}
                            placeholder="0"
                            onValueChange={v =>
                                setValues(values => {
                                    values.increaseCurrentElectricElevator.value.demand.amount =
                                        v.floatValue || null;
                                })
                            }
                            error={values.increaseCurrentElectricElevator.error != null}
                        />
                        <br />
                        <FormControlLabel
                            style={{ marginBottom: 24 }}
                            isCheckBox={true}
                            control={
                                <Checkbox
                                    value="ja"
                                    checked={values.increaseCurrentElectricElevator.value.notKnown}
                                    onChange={(event, checked) =>
                                        setValues(values => {
                                            values.increaseCurrentElectricElevator.value.notKnown = checked;
                                        })
                                    }
                                />
                            }
                            label="Leistungswert nicht bekannt"
                            error={false}
                        />
                    </Fragment>
                }
            />
        </Fragment>
    );
};
